<template>
    <v-container class="fill-height eservice_type" fluid>
      <v-layout class="eservice_inner_wrap login_wrap type2 content_type">
        <v-flex class="pa-0 login_content type2">
          <v-card class="login_form type2 type3" flat>
            <h3 class="out_title mb-15">{{$t('user.profile.title')}}</h3>

            <!-- Tab Area -->
            <v-tabs
              class="login_form tabs type2 type3"
              flat
              v-model="activeTab"
              dense
              grow
              hide-slider
              show-arrows
              next-icon="mdi-arrow-right-bold-box-outline"
              prev-icon="mdi-arrow-left-bold-box-outline"
            >
              <v-tab href="#tab-1" class="tab_btn" @click="title = $t('user.profile.title')">{{ $t('user.profile.title') }}</v-tab>
              <v-tab href="#tab-2" class="tab_btn" v-if="ind_representative == 'Y'" @click="title = $t('user.company_information.title')">{{ $t('user.company_information.title') }}</v-tab>
              <v-tab href="#tab-3" class="tab_btn" @click="title = $t('user.change_password.title')">{{ $t('user.change_password.title') }}</v-tab>
              <v-tab href="#tab-4" class="tab_btn" @click="title = $t('user.two_factor.title')">{{ $t('user.two_factor.title') }}</v-tab>
              <v-tab href="#tab-5" class="tab_btn" v-if="ind_representative == 'Y'" @click="title = $t('user.signature.title')">{{ $t('user.signature.title') }}</v-tab>

              <v-tabs-items v-model="activeTab" touchless>
                <!-- Profile -->
                <v-tab-item value="tab-1">
                  <v-form
                    v-model="valid_profile"
                    lazy-validation
                    data-vv-scope="scope_profile"
                  >
                    <v-card-text class="pa-0 inner_item_content bd_none">
                      <v-row class="ma-0">
                        <v-col cols="12" class="pa-0 avatar_jn">
                          <v-flex class="avatar_text">
                            {{ $t('user.profile.fields.avatar') }}
                          </v-flex>
                          <v-flex class="avatar_wrapper">
                            <input
                              class="hide"
                              ref="uploadAvatarFile"
                              type="file"
                              accept=".jpg,.gif,.png"
                              @change="fnPreviewAvatar()"
                            >
                            <v-avatar size="130" class="pic_img ">
                              <v-img :src="avatarSrc" alt=""/>
                            </v-avatar>
                            <v-btn
                              elevation="5"
                              icon class="pencil_btn"
                              @click="fnOpenAvatarUpload()"
                            >
                              <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                          </v-flex>

                        </v-col>
                      </v-row>
                    </v-card-text>

                    <!-- Profile > Name -->
                    <h2 class="login_f_title mt-25">{{ $t('user.profile.fields.name') }}</h2>
                    <v-card-text class="pa-0 inner_item_content mb-50">
                      <v-row class="ma-0">
                        <v-col cols="12" class="pa-0 mb-35">
                          <h2 class="nec_title mb-15"><i>*</i> {{ $t('user.profile.fields.english_name') }}</h2>
                          <v-text-field
                              label=""
                              v-model="name_en"
                              v-validate="{required: true}"
                              :error-messages="errors.collect('scope_profile.english_name')"
                              name="english_name"
                              :data-vv-as="$t('user.profile.fields.english_name')"
                              solo
                              outlined
                              flat
                              dense
                              append-icon="mdi-alert"
                              :placeholder="$t('user.profile.fields.english_name')"
                              class="login_text_filed"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row class="ma-0">
                        <v-col cols="12" class="pa-0 mb-35">
                          <h2 class="nec_title mb-15"><i>*</i> {{ $t('user.profile.fields.arabic_name') }}</h2>
                          <v-text-field
                              label=""
                              v-model="name_ar"
                              v-validate="{required: true}"
                              :error-messages="errors.collect('scope_profile.arabic_name')"
                              name="arabic_name"
                              :data-vv-as="$t('user.profile.fields.arabic_name')"
                              solo
                              outlined
                              flat
                              dense
                              append-icon="mdi-alert"
                              :placeholder="$t('user.profile.fields.arabic_name')"
                              class="login_text_filed arabic_align"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row class="ma-0">
                        <v-col cols="12" class="pa-0 mb-35">
                          <h2 class="nec_title mb-15"><i>*</i> {{ $t('user.profile.fields.birth') }}</h2>
                          <v-menu
                            ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                label=""
                                v-model="birthday_date"
                                v-validate="{required: true}"
                                :error-messages="errors.collect('scope_profile.birthday_date')"
                                name="birthday_date"
                                :data-vv-as="$t('user.profile.fields.birth')"
                                placeholder="DD-MM-YYYY format"
                                v-bind="attrs"
                                v-on="on"
                                solo
                                outlined
                                flat
                                dense
                                append-icon="mdi-alert"
                                class="login_text_filed"
                                readonly
                                @click:append="menu = true"
                            ></v-text-field>
                            </template>
                            <v-date-picker v-model="date" :max="today" no-title @input="menu = false"></v-date-picker>
                          </v-menu>
                        </v-col>
                      </v-row>
                      <v-row class="ma-0">
                        <v-col cols="12" class="pa-0 mb-35">
                          <h2 class="nec_title mb-15"><i>*</i> {{ $t('user.profile.fields.gender') }}</h2>
                          <v-select
                            hide-details
                            :items="$vuetify.rtl ? genderListAr : genderListEn"
                            v-model="gender_type_code"
                            solo
                            flat
                            outlined
                            dense
                            class="select_h40 login_select_box bdr_none"
                          ></v-select>
                        </v-col>
                      </v-row>
                      <v-row class="ma-0">
                          <v-col class="pa-0">
                            <h2 class="nec_title mb-15"><i>*</i> {{ $t('user.profile.fields.nationality') }}</h2>
                            <v-select
                              v-model="nationality_code"
                              :items="$vuetify.rtl ? countryArList : countryEnList"
                              hide-details
                              solo
                              flat
                              outlined
                              dense
                              class="select_h40 login_select_box bdr_none"
                            ></v-select>
                          </v-col>
                        </v-row>
                    </v-card-text>

                    <!-- Profile > Contact No -->
                    <h2 class="login_f_title">{{ $t('user.profile.fields.contact_no') }}</h2>
                    <v-card-text class="pa-0 inner_item_content mb-30">
                      <v-row class="ma-0">
                        <v-col cols="12" class="pa-0 mb-35">
                          <h2 class="nec_title mb-15"><i>*</i> {{ $t('user.profile.fields.telephone') }}</h2>
                          <v-text-field
                              label=""
                              v-model="telephone"
                              v-validate="{required: true}"
                              :error-messages="errors.collect('scope_profile.telephone')"
                              name="telephone"
                              :data-vv-as="$t('user.profile.fields.telephone')"
                              solo
                              outlined
                              flat
                              dense
                              append-icon="mdi-alert"
                              placeholder=""
                              class="login_text_filed"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row class="ma-0">
                        <v-col cols="12" class="pa-0 mb-35">
                          <h2 class="nec_title mb-15">{{ $t('user.profile.fields.mobile') }}</h2>
                          <v-text-field
                              label=""
                              v-model="mobile"
                              maxlength="64"
                              solo
                              outlined
                              flat
                              dense
                              append-icon="mdi-alert"
                              placeholder=""
                              class="login_text_filed"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row class="ma-0">
                        <v-col cols="12" class="pa-0">
                          <h2 class="nec_title mb-15">{{ $t('user.profile.fields.fax') }}</h2>
                          <v-text-field
                              label=""
                              v-model="fax"
                              maxlength="64"
                              solo
                              outlined
                              flat
                              dense
                              append-icon="mdi-alert"
                              placeholder=""
                              class="login_text_filed"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-card-text>

                    <!-- Profile > Proof of Identity -->
                    <h2 class="login_f_title mt-40">{{ $t('user.profile.fields.proof_of_identity') }}</h2>
                    <v-card-text class="pa-0 inner_item_content pa-0 mb-30">
                      <v-row class="ma-0">
                        <v-col cols="12" class="pa-0">
                          <h2 class="nec_title mb-15 proof__contents">
                            {{ $t('user.profile.fields.id_card_or_passport') }}
                            <v-spacer class="hidden_lr5"></v-spacer>
                            <span class="expired_wrap">({{ $t('user.profile.fields.expired') }} : {{ valid_until_date }})</span>
                            <v-spacer></v-spacer>
                          </h2>
                          <div class="d-flex align-center">
                            <a :href="downLoadUrl + id_card_file_key" style="text-decoration: none; color:#222;" class="ft-size12" v-if="id_card_file_name">
                              <v-icon>mdi-paperclip</v-icon>
                              {{ id_card_file_name }}
                            </a>
                            <v-spacer></v-spacer>
                            <v-btn
                              dark
                              color="#a01c2a"
                              class="ft-size12 text-capitalize t_search_btn wp50"
                              @click="fnOpenProofOfIdentfy()"
                            >
                              {{ $t('common.button.renew') }}
                            </v-btn>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>

                    <v-row class="ma-0 btn_wrap pb-50">
                      <v-col>
                        <v-btn class="sign_in_btn type2 colorwh" text @click="fnSaveProfile()">{{ $t('common.button.save') }}</v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-tab-item>

                <!-- Company Information -->
                <v-tab-item v-if="ind_representative == 'Y'" value="tab-2">
                  <v-form
                    v-model="valid_company"
                    lazy-validation
                    data-vv-scope="scope_company"
                  >
                    <!-- Company Information > Company Name -->
                    <h2 class="login_f_title mt-25">{{ $t('signup.agent.regist.fields.representative_patent_attorney_information') }}</h2>
                    <v-card-text class="pa-0 inner_item_content">
                      <v-row class="ma-0">
                        <v-col cols="12" class="pa-0 mb-35">
                          <h2 class="nec_title mb-15">{{ $t('signup.agent.regist.fields.patent_attorney_license_no') }}</h2>
                          <v-text-field
                              label=""
                              v-model="agent_no"
                              solo
                              outlined
                              flat
                              dense
                              clearable
                              append-icon="mdi-alert"
                              class="login_text_filed"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row class="ma-0">
                        <v-col cols="12" class="pa-0 mb-35">
                          <h2 class="nec_title mb-15"><i>*</i>{{ $t('signup.agent.regist.fields.agent_type') }}</h2>
                          <v-select
                              :items="$vuetify.rtl ? agentTypeCodeListAr : agentTypeCodeListEn"
                              v-model="agent_type_code"
                              v-validate="{required: true}"
                              :error-messages="errors.collect('scope_company.agent_type_code')"
                              name="agent_type_code"
                              solo
                              flat
                              outlined
                              dense
                              clearable
                              class="select_h40 login_select_box bdr_none"
                            ></v-select>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <h2 class="login_f_title mt-40">{{ $t('user.company_information.title') }}</h2>
                    <h2 class="login_f_title type2">{{ $t('user.company_information.fields.company_name') }}</h2>
                    <v-card-text class="pa-0 inner_item_content">
                      <v-row class="ma-0">
                        <v-col cols="12" class="pa-0 mb-35">
                          <h2 class="nec_title mb-15"><i>*</i> {{ $t('user.company_information.fields.english_name') }}</h2>
                          <v-text-field
                              label=""
                              solo
                              outlined
                              flat
                              dense
                              :placeholder="$t('user.company_information.fields.english_name')"
                              append-icon="mdi-alert"
                              class="login_text_filed"
                              v-model="company.name_en"
                              v-validate="{required: true}"
                              :error-messages="errors.collect('scope_company.name_en')"
                              name="name_en"
                              :data-vv-as="$t('user.company_information.fields.english_name')"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" class="pa-0">
                          <h2 class="nec_title mb-15"><i>*</i> {{ $t('user.company_information.fields.arabic_name') }}</h2>
                          <v-text-field
                              label=""
                              solo
                              outlined
                              flat
                              dense
                              :placeholder="$t('user.company_information.fields.arabic_name')"
                              append-icon="mdi-alert"
                              class="login_text_filed arabic_align"
                              v-model="company.name_ar"
                              v-validate="{required: true}"
                              :error-messages="errors.collect('scope_company.name_ar')"
                              name="name_ar"
                              :data-vv-as="$t('user.company_information.fields.arabic_name')"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-card-text>

                    <!-- Company Information > Address -->
                    <h2 class="login_f_title type2">{{ $t('user.company_information.fields.address') }}</h2>
                    <v-card-text class="pa-0 inner_item_content">
                      <v-row class="ma-0">
                        <v-col cols="12" class="pa-0 mb-60">
                          <h2 class="nec_title mb-15"><i>*</i> {{ $t('user.company_information.fields.english_address') }}</h2>
                          <v-row class="ma-0 mb-20">
                            <v-col class="pa-0">
                              <h2 class="italic_title mb--10">{{ $t('user.company_information.fields.street_address') }}</h2>
                              <v-text-field
                                label=""
                                solo
                                outlined
                                flat
                                dense
                                placeholder=""
                                append-icon="mdi-alert"
                                class="login_text_filed"
                                v-model="company.address_en"
                                v-validate="{required: true}"
                                :error-messages="errors.collect('scope_company.address_en')"
                                name="address_en"
                                :data-vv-as="$t('user.company_information.fields.street_address')"
                            ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row class="ma-0 mb-20">
                            <v-col class="pa-0">
                              <h2 class="italic_title mb--10">{{ $t('user.company_information.fields.city') }}</h2>
                              <v-text-field
                                label=""
                                solo
                                outlined
                                flat
                                dense
                                placeholder=""
                                append-icon="mdi-alert"
                                class="login_text_filed"
                                v-model="company.city_name_en"
                                v-validate="{required: true}"
                                :error-messages="errors.collect('scope_company.city_name_en')"
                                name="city_name_en"
                                :data-vv-as="$t('user.company_information.fields.city')"
                            ></v-text-field>
                            </v-col>
                            <v-spacer class="hidden_lr5"></v-spacer>
                            <v-col class="pa-0">
                              <h2 class="italic_title mb--10">{{ $t('user.company_information.fields.country') }}</h2>
                              <v-select
                                hide-details
                                :items="countryEnList"
                                v-model="company.residence_country_code"
                                solo
                                flat
                                outlined
                                dense
                                class="select_h40 login_select_box bdr_none bgf5f5f5"
                              ></v-select>
                            </v-col>
                          </v-row>
                          <v-row class="ma-0">
                            <v-col class="pa-0">
                              <h2 class="italic_title mb--10">{{ $t('user.company_information.fields.pobox') }}</h2>
                              <v-text-field
                                label=""
                                solo
                                outlined
                                flat
                                dense
                                placeholder=""
                                append-icon="mdi-alert"
                                class="login_text_filed"
                                v-model="company.pobox_en"
                                v-validate="{required: false}"
                                :error-messages="errors.collect('scope_company.pobox_en')"
                                name="pobox_en"
                                :data-vv-as="$t('user.company_information.fields.pobox')"
                            ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-col>

                        <v-col cols="12" class="pa-0 mb-60">
                          <h2 class="nec_title mb-15"><i>*</i> {{ $t('user.company_information.fields.arabic_address') }}</h2>
                          <v-row class="ma-0 mb-20">
                            <v-col class="pa-0">
                              <h2 class="italic_title mb--10">{{ $t('user.company_information.fields.street_address') }}</h2>
                              <v-text-field
                                label=""
                                solo
                                outlined
                                flat
                                dense
                                placeholder=""
                                append-icon="mdi-alert"
                                class="login_text_filed arabic_align"
                                v-model="company.address_ar"
                                v-validate="{required: true}"
                                :error-messages="errors.collect('scope_company.address_ar')"
                                name="address_ar"
                                :data-vv-as="$t('user.company_information.fields.street_address')"
                            ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row class="ma-0 mb-20">
                            <v-col class="pa-0">
                              <h2 class="italic_title mb--10">{{ $t('user.company_information.fields.city') }}</h2>
                              <v-text-field
                                label=""
                                solo
                                outlined
                                flat
                                dense
                                placeholder=""
                                append-icon="mdi-alert"
                                class="login_text_filed arabic_align"
                                v-model="company.city_name_ar"
                                v-validate="{required: true}"
                                :error-messages="errors.collect('scope_company.city_name_ar')"
                                name="city_name_ar"
                                :data-vv-as="$t('user.company_information.fields.city')"
                            ></v-text-field>
                            </v-col>
                            <v-spacer class="hidden_lr5"></v-spacer>
                            <v-col class="pa-0">
                              <h2 class="italic_title mb--10">{{ $t('user.company_information.fields.country') }}</h2>
                              <v-select
                                hide-details
                                :items="countryArList"
                                v-model="company.residence_country_code"
                                solo
                                flat
                                :reverse="$vuetify.rtl? false : true"
                                outlined
                                dense
                                class="select_h40 login_select_box bdr_none bgf5f5f5 arabic_align "
                              ></v-select>
                            </v-col>
                          </v-row>

                          <v-row class="ma-0 mb-35">
                            <v-col class="pa-0">
                              <h2 class="italic_title mb--10">{{ $t('user.company_information.fields.pobox') }}</h2>
                              <v-text-field
                                label=""
                                solo
                                outlined
                                flat
                                dense
                                placeholder=""
                                append-icon="mdi-alert"
                                class="login_text_filed arabic_align"
                                v-model="company.pobox_ar"
                                v-validate="{required: false}"
                                :error-messages="errors.collect('scope_company.pobox_ar')"
                                name="pobox_ar"
                                :data-vv-as="$t('user.company_information.fields.pobox')"
                            ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-col>


                        <v-col cols="12" class="pa-0">
                          <h2 class="nec_title mb-15">{{ $t('user.company_information.fields.postal') }}</h2>
                          <v-text-field
                              label=""
                              solo
                              outlined
                              flat
                              dense
                              append-icon="mdi-alert"
                              class="login_text_filed"
                              v-model="company.postal"
                              v-validate="{required: false}"
                              :error-messages="errors.collect('scope_company.postal')"
                              name="postal"
                              :data-vv-as="$t('user.company_information.fields.postal')"
                              maxlength="16"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-card-text>

                    <!-- Company Information > Contact No -->
                    <h2 class="login_f_title type2">{{ $t('user.company_information.fields.contact_no') }}</h2>
                    <v-card-text class="pa-0 inner_item_content">
                      <v-row class="ma-0">
                        <v-col cols="12" class="pa-0 mb-35">
                          <h2 class="nec_title mb-15"><i>*</i> {{ $t('user.company_information.fields.telephone') }}</h2>
                          <v-text-field
                              label=""
                              solo
                              outlined
                              flat
                              dense
                              :placeholder="$t('user.company_information.fields.telephone')"
                              append-icon="mdi-alert"
                              class="login_text_filed"
                              v-model="company.telephone"
                              v-validate="{required: true}"
                              :error-messages="errors.collect('scope_step2.telephone')"
                              name="telephone"
                              :data-vv-as="$t('user.company_information.fields.telephone')"
                              maxlength="64"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" class="pa-0 mb-35">
                          <h2 class="nec_title mb-15">{{ $t('user.company_information.fields.mobile') }}</h2>
                          <v-text-field
                              label=""
                              solo
                              outlined
                              flat
                              dense
                              :placeholder="$t('user.company_information.fields.mobile')"
                              append-icon="mdi-alert"
                              class="login_text_filed"
                              v-model="company.mobile"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" class="pa-0">
                          <h2 class="nec_title mb-15">{{ $t('user.company_information.fields.fax') }}</h2>
                          <v-text-field
                              label=""
                              solo
                              outlined
                              flat
                              dense
                              :placeholder="$t('user.company_information.fields.fax')"
                              append-icon="mdi-alert"
                              class="login_text_filed"
                              v-model="company.fax"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-card-text>

                    <!-- Company Information > Proof of Identity -->
                    <h2 class="login_f_title type2">{{ $t('user.company_information.fields.proof_of_identity') }}</h2>
                    <v-card-text class="pa-0 inner_item_content pa-0 mb-30">
                      <v-row class="ma-0">
                        <v-col cols="12" class="pa-0">
                          <h2 class="nec_title mb-15 d-flex align-center">
                            {{ $t('user.company_information.fields.registry_cert') }}
                            <v-spacer class="hidden_lr2"></v-spacer>
                            <span class="expired_wrap">({{ $t('user.profile.fields.expired') }} : {{ valid_until_date }})</span>
                            <v-spacer></v-spacer>
                          </h2>
                          <div class="d-flex align-center">
                            <a :href="downLoadUrl + company.registry_cert_file_key" style="text-decoration: none; color:#222;" class="ft-size12" v-if="registry_cert_file_name">
                              <v-icon>mdi-paperclip</v-icon>
                              {{ registry_cert_file_name }}
                            </a>
                            <v-spacer></v-spacer>
                            <v-btn
                              dark
                              color="#a01c2a"
                              class="ft-size12 text-capitalize t_search_btn wp50"
                              @click="fnOpenProofOfIdentfy()"
                            >
                              {{ $t('common.button.renew') }}
                            </v-btn>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-row class="ma-0 btn_wrap pb-50">
                      <v-btn class="sign_in_btn type2 colorwh" text @click="fnSaveCompany()">{{ $t('common.button.save') }}</v-btn>
                    </v-row>
                  </v-form>
                </v-tab-item>

                <!-- Change Password -->
                <v-tab-item value="tab-3">
                  <v-form
                    v-model="valid_password"
                    lazy-validation
                    data-vv-scope="scope_password"
                  >
                    <h2 class="login_f_title mt-40">{{ $t('user.change_password.title') }}</h2>
                    <v-card-text class="pa-0 inner_item_content mb-30">
                      <v-row class="ma-0">
                        <v-col cols="12" class="pa-0 mb-25">
                          <h2 class="nec_title mb-15"><i>*</i> {{ $t('user.change_password.fields.email') }}</h2>
                          <h3 class="inner_title type2">{{email}}</h3>
                        </v-col>

                        <v-card
                          flat
                          class="foot__info type2 mb-35"
                        >
                          <v-card-text class="pa-0">
                            <h2>{{ $t('user.change_password.fields.password_rule_title') }}</h2>
                            <div class="d-flex">
                              <v-spacer class="hidden_lr22 d-inline-block"></v-spacer>
                              <p class="d-inline-block">{{ $t('user.change_password.fields.password_rule_desc_1') }}</p>
                            </div>
                            <div class="d-flex">
                              <v-spacer class="hidden_lr22 d-inline-block"></v-spacer>
                              <p class="d-inline-block">{{ $t('user.change_password.fields.password_rule_desc_2') }}</p>
                            </div>
                          </v-card-text>
                        </v-card>

                        <v-col cols="12" class="pa-0 mb-35">
                          <h2 class="nec_title mb-15"><i>*</i> {{ $t('user.change_password.fields.current_password') }}</h2>
                          <v-text-field
                              label=""
                              solo
                              outlined
                              flat
                              dense
                              append-icon="mdi-alert"
                              type="password"
                              class="login_text_filed"
                              v-model="current_password"
                              v-validate="{required: true}"
                              :error-messages="errors.collect('scope_password.current_password')"
                              name="current_password"
                              :data-vv-as="$t('user.change_password.fields.current_password')"
                              :disabled="!blnPassword"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" class="pa-0 mb-35">
                          <h2 class="nec_title mb-15"><i>*</i> {{ $t('user.change_password.fields.new_password') }}</h2>
                          <v-text-field
                              label=""
                              solo
                              outlined
                              flat
                              dense
                              append-icon="mdi-alert"
                              type="password"
                              class="login_text_filed"
                              v-model="new_password"
                              v-validate="{required: true, password_rule: true}"
                              :error-messages="errors.collect('scope_password.new_password')"
                              name="new_password"
                              :data-vv-as="$t('user.change_password.fields.new_password')"
                              :disabled="!blnPassword"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" class="pa-0">
                          <h2 class="nec_title mb-15"><i>*</i> {{ $t('user.change_password.fields.verify_password') }}</h2>
                          <v-text-field
                              label=""
                              solo
                              outlined
                              flat
                              dense
                              append-icon="mdi-alert"
                              type="password"
                              class="login_text_filed"
                              v-model="verify_password"
                              v-validate="{required: true, password_match: true}"
                              :error-messages="errors.collect('scope_password.verify_password')"
                              name="verify_password"
                              :data-vv-as="$t('user.change_password.fields.verify_password')"
                              :disabled="!blnPassword"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-card-text>

                    <v-row class="ma-0 btn_wrap pb-50" v-if="!blnPassword">
                      <v-btn class="sign_in_btn btn-dactv" text @click="blnPassword = true">{{ $t('common.button.edit') }}</v-btn>
                    </v-row>
                    <v-row class="ma-0 btn_wrap pb-50" v-if="blnPassword">
                      <v-btn class="sign_in_btn type2 colorwh" text @click="fnChangePassword()">{{ $t('common.button.save') }}</v-btn>
                    </v-row>
                  </v-form>
                </v-tab-item>

                <!-- Set Two-Factor AUTHENTICATION -->
                <v-tab-item value="tab-4">
                  <v-form
                    v-model="valid_twofactor"
                    lazy-validation
                    data-vv-scope="scope_twofactor"
                  >
                    <h2 class="login_f_title mt-40">{{ $t('user.two_factor.title') }}</h2>
                    <v-card-text class="pa-0 inner_item_content">
                      <v-row class="ma-0">
                        <v-col cols="12" class="pa-0">
                          <h2 class="nec_title mb-15"><i>*</i> {{ $t('user.two_factor.fields.select_two_factor') }}</h2>
                          <v-select
                            v-model="strong_auth_type_code"
                            hide-details
                            :items="$vuetify.rtl ? methodListAr : methodListEn"
                            solo
                            flat
                            outlined
                            dense
                            class="select_h40 login_select_box bdr_none"
                            :disabled="!blnTwoFactor"
                          ></v-select>
                        </v-col>
                      </v-row>
                    </v-card-text>

                    <!-- Set Two-Factor AUTHENTICATION > Google OTP -->
                    <h2 class="login_f_title type2" v-show="strong_auth_type_code == '3703'">{{ $t('user.two_factor.fields.google_otp') }}</h2>
                    <v-card-text class="pa-0 inner_item_content mb-30" v-show="strong_auth_type_code == '3703'">
                      <v-row class="ma-0">
                        <v-col cols="12" class="pa-0 mb-30">
                          <div class="otp_box">
                            <v-img :src="qrcode_url"></v-img>
                          </div>
                        </v-col>
                        <v-col cols="12" class="pa-0">
                          <h2 class="nec_title mb-15"><i>*</i> {{ $t('user.two_factor.fields.google_auth_code') }}</h2>
                          <v-text-field
                            label=""
                            solo
                            outlined
                            flat
                            dense
                            clearable
                            maxlength="6"
                            append-icon="mdi-alert"
                            type="password"
                            class="login_text_filed"
                            v-model="otp_code"
                            v-validate="{required: valid_google, pincode_rule: valid_google}"
                            :error-messages="errors.collect('scope_twofactor.otp_code')"
                            name="otp_code"
                            :data-vv-as="$t('user.two_factor.fields.google_auth_code')"
                            :disabled="!blnTwoFactor"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-card-text>

                    <!-- Set Two-Factor AUTHENTICATION > PIN Code -->
                    <h2 class="login_f_title type2" v-show="strong_auth_type_code == '3702'">{{ $t('user.two_factor.fields.pin_code') }}</h2>
                    <v-card-text class="pa-0 inner_item_content mb-30" v-show="strong_auth_type_code == '3702'">
                      <v-row class="ma-0">
                        <v-card
                          flat
                          class="foot__info type2 mb-35"
                        >
                          <v-card-text class="pa-0">
                            <h2>{{ $t('signup.agent.regist.fields.password_rule_title') }}</h2>
                            <div class="d-flex">
                              <v-icon class="chk active" :disabled="pinCodeNotMatche">mdi-check-bold</v-icon>
                              <p class="d-inline-block">{{ $t('signup.agent.regist.fields.pin_code_desc') }}</p>
                            </div>
                          </v-card-text>
                        </v-card>

                        <v-col cols="12" class="pa-0 mb-30">
                          <h2 class="nec_title mb-15"><i>*</i> {{ $t('user.two_factor.fields.pin_code') }}</h2>
                          <v-text-field
                            label=""
                            solo
                            outlined
                            flat
                            dense
                            clearable
                            append-icon="mdi-alert"
                            type="password"
                            class="login_text_filed"
                            v-model="registered_pin_code"
                            v-validate="{required: valid_pincode, pincode_rule: valid_pincode}"
                            :error-messages="errors.collect('scope_twofactor.registered_pin_code')"
                            name="registered_pin_code"
                            :data-vv-as="$t('user.two_factor.fields.pin_code')"
                            :disabled="!blnTwoFactor"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" class="pa-0">
                          <h2 class="nec_title mb-15"><i>*</i> {{ $t('user.two_factor.fields.pin_code_re') }}</h2>
                          <v-text-field
                            label=""
                            solo
                            outlined
                            flat
                            dense
                            clearable
                            append-icon="mdi-alert"
                            type="password"
                            class="login_text_filed"
                            v-model="registered_pin_code_re"
                            v-validate="{required: valid_pincode, pincode_match: valid_pincode}"
                            :error-messages="errors.collect('scope_twofactor.registered_pin_code_re')"
                            name="registered_pin_code_re"
                            :data-vv-as="$t('user.two_factor.fields.pin_code_re')"
                            :disabled="!blnTwoFactor"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-card-text>

                    <v-row class="ma-0 btn_wrap pb-50" v-if="!blnTwoFactor">
                      <v-btn class="sign_in_btn btn-dactv" text @click="blnTwoFactor = true">{{ $t('common.button.edit') }}</v-btn>
                    </v-row>
                    <v-row class="ma-0 btn_wrap pb-50" v-if="blnTwoFactor">
                      <v-btn class="sign_in_btn type2 colorwh" text @click="fnChangeTwoFactor()">{{ $t('common.button.save') }}</v-btn>
                    </v-row>
                  </v-form>
                </v-tab-item>

                <!-- Signature / Proof of doc -->
                <v-tab-item v-if="ind_representative == 'Y'" value="tab-5">
                  <v-form
                    v-model="valid_signature"
                    lazy-validation
                    data-vv-scope="scope_signature"
                  >
                    <h2 class="login_f_title mt-40">{{ $t('user.signature.title') }}</h2>
                    <v-card-text class="pa-0 inner_item_content pa-0 mb-30">
                       <v-row class="ma-0 mt-15">
                        <v-col cols="4" class="pa-0" style="border:1px solid #ddd;">
                          <v-img
                            v-show="signSrc"
                            :src="signSrc"
                          >
                          </v-img>
                        </v-col>
                        <v-col cols="8" class="mt-100">
                          <v-spacer></v-spacer>
                          <v-btn
                            class="ft-size12 text-capitalize t_search_btn wp50 btn-dactv"
                            @click="fnSetSignature()">{{ $t('common.button.edit') }}</v-btn>
                        </v-col>
                      </v-row>
                    </v-card-text>

                    <v-row class="ma-0 btn_wrap pb-50">
                      <v-btn class="sign_in_btn type2 colorwh" text @click="fnSaveSign()">{{ $t('common.button.save') }}</v-btn>
                    </v-row>
                  </v-form>
                </v-tab-item>
              </v-tabs-items>
            </v-tabs>
          </v-card>

        </v-flex>

      </v-layout>

      <ProofOfIdentify ref="proofIdentifyModal" @success="fnModalSuccess()"/>

      <Signature ref="signature" @success="fnGetSignImg" />
    </v-container>

</template>

<script>
import requestApi from '@/utils/requestApi'
import store from '@/store'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import ProofOfIdentify from './ProofOfIdentify.vue'
import Signature from './Signature.vue'

export default {
  name: 'AgentProfile',
  components: {
    ProofOfIdentify,
    Signature
  },
  data () {
    return {
      // 사인
      img_src : '',


      activeTab : 'tab-1',
      menu : false,

      date: new Date().toISOString().substr(0, 10),
      today: new Date(new Date().setDate(new Date().getDate() - 1)).toISOString().substr(0, 10),

      downLoadUrl : process.env.VUE_APP_BASE_URL + '/file/download/',

      avatarFile : null,
      //idCardFile : null,
      //registryCertFile : null,
      id_card_file_name : '',
      registry_cert_file_name : '',


      signFile : null,
      avatarSrc : '',
      signSrc : '',
      pinCodeNotMatche : true,

      methodListAr : [],
      methodListEn: [],
      genderListAr: [],
      genderListEn: [],
      countryEnList: [],
      countryArList: [],

      valid_profile : true,
      valid_company : true,
      valid_password : true,
      valid_twofactor : true,
      valid_signature : true,

      valid_pincode : false,
      valid_google : false,

      //개인회원 profile
      seq : '',
      company_seq : '',
      email : '',
      lasted_login_date : '',
      login_failed_count : '',
      account_lock_date : '',
      user_status_type_code : '',
      name_ar : '',
      name_en : '',
      personal_identify_no : '',
      valid_until_date : '',
      strong_auth_type_code : '',
      user_group_type_code : '',
      user_type_code : '',
      agent_no : '',
      agent_type_code: '',
      birthday_date : '',
      gender_type_code : '',
      id_card_file_key : '',
      address_ar : '',
      address_en : '',
      city_name_ar : '',
      city_name_en : '',
      residence_country_code : '',
      pobox_ar : '',
      pobox_en : '',
      postal : '',
      nationality_code : '',
      telephone : '',
      mobile : '',
      fax : '',
      avatar_file_key : '',
      sign_file_key : '',
      ind_representative : '',
      agent_authorization_type_code : '',
      ind_active : '',

      //Company Information
      company : {
        seq : '',
        company_type_code : '',
        company_regiration_no : '',
        name_ar : '',
        name_en : '',
        address_ar : '',
        address_en : '',
        city_name_ar : '',
        city_name_en : '',
        residence_country_code : '',
        residence_country_name_ar : '',
        residence_country_name_en : '',
        pobox_ar : '',
        pobox_en : '',
        postal : '',
        registry_cert_file_key : '',
        company_status_type_code : '',
        telephone : '',
        mobile : '',
        fax : '',
        representative_email : ''
      },

      //비밀번호 변경
      current_password : '',
      new_password : '',
      verify_password : '',

      blnPassword: false,
      blnTwoFactor: false,

      //Google Otp 관련
      qrcode_url : '',
      encode_key : '',
      otp_code : '',

      //pin-code
      registered_pin_code : '',
      registered_pin_code_re : '',


      agentTypeCodeListAr: [],
      agentTypeCodeListEn: [],

      title : this.$t("user.profile.title")
    }
  },
  beforeCreate() {

    utils.fnGetCountryList('en').then(list => {
      this.countryEnList = list
    }).catch((res)=>{
      eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
    })

    utils.fnGetCountryList('ar').then(list => {
      this.countryArList = list
    }).catch((res)=>{
      eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
    })

    let options = {
      upper_code: '4000'
    }
    utils.fnGetCodeList(options).then(list => {
      this.genderListAr = list.ar
      this.genderListEn = list.en

      if(this.genderListAr.length > 0){
        this.gender_type_code = this.genderListAr[0].value
      }
    })

    options = {
      upper_code: '3700',
      remove: [
        {code: '3701'}
      ]
    }
    utils.fnGetCodeList(options).then(list => {
      this.methodListAr = list.ar
      this.methodListEn = list.en

      if(this.methodListAr.length > 0){
        this.strong_auth_type_code = this.methodListAr[0].value
      }
    })

    options = {
      upper_code: '3100'
    }
    utils.fnGetCodeList(options).then(list => {
      this.agentTypeCodeListAr = list.ar
      this.agentTypeCodeListEn = list.en
    })
  },
  created () {

    this.$validator.extend('password_rule',{
      getMessage: field => field+' is not meet the required security level',
      validate: value => {
        //소문자 대문자 숫자 (8,32)
        let check_1 = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{8,32}/.test(value)

        //소문자 대문자 특수문자 (8,32)
        let check_2 = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&+=])[A-Za-z!@#$%^&+=]{8,32}/.test(value)

        //소문자 숫자 특수문자 (8,32)
        let check_3 = /^(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&+=])[a-z\d!@#$%^&+=]{8,32}/.test(value)

        //대문자 숫자 특수문자 (8,32)
        let check_4 = /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&+=])[A-Z\d!@#$%^&+=]{8,32}/.test(value)

        //소문자 대문자 숫자 특수문자(8,32)
        let check_5 = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&+=])[A-Za-z\d!@#$%^&+=]{8,32}/.test(value)

        let result = false
        if(check_1 || check_2 || check_3 || check_4 || check_5){
          result = true
        }

        return result
      }
    })

    this.$validator.extend('password_match', {
      getMessage: field => field+' is not matched',
      validate: value => {

        let target = this.$validator.fields.find({name: 'new_password'})
        return value == target.value

      }
    })

    this.$validator.extend('pincode_rule',{
      getMessage: field => field+' must be 6 Decimal digit numbers',
      validate: value => {
        //숫자(6)
        let check = /^\d{6}$/.test(value)

        if(check){
          this.pinCodeNotMatche = false
        }else{
          this.pinCodeNotMatche = true
        }

        return check
      }
    })

    this.$validator.extend('pincode_match', {
      getMessage: field => field+' is not matched',
      validate: value => {

        let target = this.$validator.fields.find({name: 'registered_pin_code'})

        return value == target.value

      }
    })

    this.$validator.extend('file_rule', {
      getMessage: field => field+' size should be less than 20 MB!',
      validate: value => {

        let result = true

        if(value.size > 1024 * 1024 * 20){
          result = false
        }
        return result
      }
    })
  },
  watch: {
    date () {
      this.birthday_date = this.formatDate(this.date)
    },
    new_password() {
      this.$validator.validate('scope_password.verify_password')
    },
    registered_pin_code() {
      this.$validator.validate('scope_twofactor.registered_pin_code_re')
    },
    strong_auth_type_code() {
      this.$validator.reset()

      this.valid_pincode = false
      this.valid_google = false

      if(this.strong_auth_type_code == '3702'){
        this.valid_google = false
        this.valid_pincode = true
      }else if(this.strong_auth_type_code == '3703'){
        this.valid_google = true
        this.valid_pincode = false
      }else if(this.strong_auth_type_code == '3704'){
        this.valid_google = false
        this.valid_pincode = false
      }
    },
    signFile(val){
      if(!val){
        this.fnClearSignFile()
      }
    }
  },
  mounted () {
    this.fnGetProfile()
    this.fnGetCompanyInfo()

    if (store.state.token.user_group_type_code === '3804') {
      this.ind_representative = 'Y'
    }

    // agent information 에서 넘어 왔을 때
    if (this.$route.query.tab !== '') {
      this.activeTab = this.$route.query.tab
    }
  },
  methods: {
    // 사인
    fnGetSignImg(imgStr){
      this.signSrc = imgStr
      let option = {
        text: this.$t('common.message.save_image_info')
      }
      eventBus.$emit('SHOW_SNACKBAR', option)
    },
    fnChangeSignFile(){
      if(this.signFile){
        let file = this.signFile

        let extList = []
        extList.push({name_en: 'jpg'})
        extList.push({name_en: 'gif'})
        extList.push({name_en: 'png'})

        if (utils.getFileExtLen(file, extList, this.$t('common.message.file_extension_error')) === -1) {
          setTimeout(() => {
            this.signFile = null
          }, 100)

          return
        }

        this.img_src = URL.createObjectURL(file)
      }
    },
    fnCheckSize(){
      let img = document.getElementById('check_img')
      let width = img.naturalWidth
      let height = img.naturalHeight

      if(width > 100 || height > 50){
        eventBus.$emit('SHOW_SNACKBAR', { text : this.$t('user.signature.fields.upload_signature') })
        this.signFile = null
        this.img_src = ''
      }else{
        let resize = document.getElementById('resize')
        let resizeCtx = resize.getContext('2d')
        resizeCtx.drawImage(img, 0, 0, width, height)
        let resizeSrc = resize.toDataURL('image/jpg')
        this.signSrc = null
        this.signSrc = resizeSrc
        this.img_src = ''

        let option = {
          text: this.$t('common.message.save_image_info')
        }
        eventBus.$emit('SHOW_SNACKBAR', option)
      }
    },

    fnGetProfile(){
      requestApi({
        url: '/users/profile',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.seq = res.data.seq
            this.company_seq = res.data.company_seq
            this.email = res.data.email
            this.lasted_login_date = res.data.lasted_login_date
            this.login_failed_count = res.data.login_failed_count
            this.account_lock_date = res.data.account_lock_date
            this.user_status_type_code = res.data.user_status_type_code
            this.name_ar = res.data.name_ar
            this.name_en = res.data.name_en
            this.personal_identify_no = res.data.personal_identify_no
            this.valid_until_date = this.$moment(res.data.valid_until_date, 'DD-MM-YYYY').format('DD/MM/YYYY')
            this.strong_auth_type_code = res.data.strong_auth_type_code
            this.user_group_type_code = res.data.user_group_type_code
            this.user_type_code = res.data.user_type_code
            this.agent_no = res.data.agent_no
            this.agent_type_code = res.data.agent_type_code
            this.birthday_date = res.data.birthday_date
            this.gender_type_code = res.data.gender_type_code
            this.id_card_file_key = res.data.id_card_file_key
            this.address_ar = res.data.address_ar
            this.address_en = res.data.address_en
            this.city_name_ar = res.data.city_name_ar
            this.city_name_en = res.data.city_name_en
            this.residence_country_code = res.data.residence_country_code
            this.pobox_ar = res.data.pobox_ar
            this.pobox_en = res.data.pobox_en
            this.postal = res.data.postal
            this.nationality_code = res.data.nationality_code
            this.telephone = res.data.telephone
            this.mobile = res.data.mobile
            this.fax = res.data.fax
            this.avatar_file_key = res.data.avatar_file_key
            this.sign_file_key = res.data.sign_file_key
            this.ind_representative = res.data.ind_representative
            this.agent_authorization_type_code = res.data.agent_authorization_type_code
            this.ind_active = res.data.ind_active

            this.id_card_file_name = res.data.id_card_file_name

            //datepicker용 date
            this.fnSetDate(res.data.birthday_date)

            //아바타 이미지 표시
            if(res.data.avatar_file_key){
              this.avatarSrc = this.downLoadUrl+res.data.avatar_file_key
            } else {
              this.avatarSrc = require("@/assets/img/avatar.png")
            }

            if(res.data.sign_image){
              this.signSrc = res.data.sign_image
            }

            //Google OTP QR Code
            this.fnGetQrCode()
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetProfile()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGetQrCode(){
      //Google OTP QR Code URL및 인증키
      let params = {
        email : this.email
      }

      requestApi({
        url: '/autho/googleotp/qrcode',
        method: 'POST',
        data: params,
        callback: (res) => {
          if (res.res_code === '200') {
            this.qrcode_url = res.data.qrcode_url
            this.encode_key = res.data.encode_key
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetQrCode()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGetCompanyInfo(){
      requestApi({
        url: '/users/company/information',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.company.seq = res.data.seq
            this.company.company_type_code = res.data.company_type_code
            this.company.company_regiration_no = res.data.company_regiration_no
            this.company.name_ar = res.data.name_ar
            this.company.name_en = res.data.name_en
            this.company.address_ar = res.data.address_ar
            this.company.address_en = res.data.address_en
            this.company.city_name_ar = res.data.city_name_ar
            this.company.city_name_en = res.data.city_name_en
            this.company.residence_country_code = res.data.residence_country_code
            this.company.residence_country_name_ar = res.data.residence_country_name_ar
            this.company.residence_country_name_en = res.data.residence_country_name_en
            this.company.pobox_ar = res.data.pobox_ar
            this.company.pobox_en = res.data.pobox_en
            this.company.postal = res.data.postal
            this.company.registry_cert_file_key = res.data.registry_cert_file_key
            this.company.company_status_type_code = res.data.company_status_type_code
            this.company.telephone = res.data.telephone
            this.company.mobile = res.data.mobile
            this.company.fax = res.data.fax
            this.company.representative_email = res.data.representative_email

            this.registry_cert_file_name = res.data.registry_cert_file_name
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetCompanyInfo()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    formatDate (date) {
      if (!date) return ''
      const [year, month, day] = date.split('-')
      return `${day}-${month}-${year}`
    },

    fnSetDate(formatDateStr){
      if (formatDateStr) {
        let dateArr = formatDateStr.split("-")
        this.date = new Date( dateArr[2] + '-' + dateArr[1] + '-' + dateArr[0] ).toISOString().substr(0, 10)
      }
    },

    fnOpenAvatarUpload(){
      this.$refs.uploadAvatarFile.click()
    },

    fnPreviewAvatar(){
      if(this.$refs['uploadAvatarFile'].files[0]){
        this.avatarFile = this.$refs['uploadAvatarFile'].files[0]

        if(this.avatarFile){
          let extList = []
          extList.push({name_en: 'jpg'})
          extList.push({name_en: 'gif'})
          extList.push({name_en: 'png'})

          if (utils.getFileExtLen(this.avatarFile, extList, this.$t('common.message.file_extension_error')) === -1) {
            setTimeout(() => {
              this.avatarFile = null
            }, 100)

            return
          }

          if( this.avatarFile.size < 1024 * 1000 * 2){
            //파일 미리보기
            let file = this.avatarFile
            this.avatarSrc = URL.createObjectURL(file)

          }else{
            eventBus.$emit('SHOW_SNACKBAR', { text : 'Image file size should be less than 2 MB!'})
            this.avatarFile = null
          }
        }
      }else{
        this.avatarFile = null
      }
    },

    fnUploadAvatarFile(){
      //업로드 할 이미지 파일이 있다면 업로드 실행
      let avatarFile = this.avatarFile
      let target = this

      return new Promise(function(resolve, reject){

        if(avatarFile){
          let formData = new FormData()
          formData.append("file_data", avatarFile)

          requestApi({
            url: '/file/documents/upload',
            method: 'POST',
            data: formData,
            headers : {"Content-Type":"multipart/form-data"},
            callback: (res) => {
              // 파일저장
              if (res.res_code === '200') {
                target.avatar_file_key = res.data.file_key
                resolve()
              }else{
                reject(res)
              }
            }
          })
        }else{
          resolve()
        }
      })
    },

    fnUploadIdCardFile(){
      //업로드 할 이미지 파일이 있다면 업로드 실행
      let idCardFile = this.idCardFile
      let target = this

      return new Promise(function(resolve, reject){

        if(idCardFile){

          let formData = new FormData()
          formData.append("file_data", idCardFile)

          requestApi({
            url: '/file/documents/upload',
            method: 'POST',
            data: formData,
            headers : {"Content-Type":"multipart/form-data"},
            callback: (res) => {
              // 파일저장
              if (res.res_code === '200') {
                target.id_card_file_key = res.data.file_key
                resolve()
              }else{
                reject(res)
              }
            }
          })
        }else{
          resolve()
        }
      })
    },

    fnUploadRegistryCertFile(){
      //업로드 할 이미지 파일이 있다면 업로드 실행
      let registryCertFile = this.registryCertFile
      let target = this

      return new Promise(function(resolve, reject){

        if(registryCertFile){

          let formData = new FormData()
          formData.append("file_data", registryCertFile)

          requestApi({
            url: '/file/documents/upload',
            method: 'POST',
            data: formData,
            headers : {"Content-Type":"multipart/form-data"},
            callback: (res) => {
              // 파일저장
              if (res.res_code === '200') {
                target.company.registry_cert_file_key = res.data.file_key
                resolve()
              }else{
                reject(res)
              }
            }
          })
        }else{
          resolve()
        }
      })
    },
    fnSaveProfile(){
      this.$validator.validateAll('scope_profile').then((result) => {
        if(result){
          this.fnUploadAvatarFile().then( () => {
            let params = {
              name_en : this.name_en,
              name_ar : this.name_ar,
              birthday_date : this.birthday_date,
              gender_type_code : this.gender_type_code,
              nationality_code : this.nationality_code,
              address_ar : this.address_ar,
              address_en : this.address_en,
              city_name_ar : this.city_name_ar,
              city_name_en : this.city_name_en,
              residence_country_code : this.residence_country_code,
              pobox_ar : this.pobox_ar,
              pobox_en : this.pobox_en,
              postal : this.postal,
              telephone : this.telephone,
              mobile : this.mobile,
              fax : this.fax,
              avatar_file_key : this.avatar_file_key
            }

            requestApi({
              url: '/users/profile',
              method: 'PUT',
              data: params,
              callback: (res) => {
                if (res.res_code === '200') {
                  let snackBarOptions = {
                    text: this.$t('common.message.modify.success')
                  }
                  eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)

                  store.dispatch('SetNameAr', this.name_ar)
                  store.dispatch('SetNameEn', this.name_en)
                  store.dispatch('SetAvatarFileKey', this.avatar_file_key)
                } else {
                  if (res.res_code === '401012') {
                    utils.setTokenRefresh().then(() => {
                      this.fnSaveProfile()
                    })
                  } else {
                    eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                  }
                }
              }
            })
          }).catch(res => {
            eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
          })
        }
      })
    },

    fnSaveCompany(){
      this.$validator.validateAll('scope_company').then((result) => {
        if(result){
          let params = {
            company_regiration_no : this.company.company_regiration_no,
            name_ar : this.company.name_ar,
            name_en : this.company.name_en,
            address_ar : this.company.address_ar,
            address_en : this.company.address_en,
            city_name_ar : this.company.city_name_ar,
            city_name_en : this.company.city_name_en,
            residence_country_code : this.company.residence_country_code,
            pobox_ar : this.company.pobox_ar,
            pobox_en : this.company.pobox_en,
            postal : this.company.postal,
            telephone : this.company.telephone,
            mobile : this.company.mobile,
            fax : this.company.fax,
            registry_cert_file_key : this.company.registry_cert_file_key,
            agent_no : this.agent_no,
            agent_type_code: this.agent_type_code
          }

          requestApi({
            url: '/users/company/information',
            method: 'PUT',
            data: params,
            callback: (res) => {
              if (res.res_code === '200') {
                let snackBarOptions = {
                  text: this.$t('common.message.modify.success')
                }
                eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)

                store.dispatch('SetCompanyNameAr', this.company.name_ar)
                store.dispatch('SetCompanyNameEn', this.company.name_en)
              } else {
                if (res.res_code === '401012') {
                  utils.setTokenRefresh().then(() => {
                    this.fnSaveCompany()
                  })
                } else {
                  eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                }
              }
            }
          })
        }
      })
    },

    fnChangePassword(){
      this.$validator.validateAll('scope_password').then((result) => {
        if(result){

          let params = {
            current_password : this.current_password,
            new_password : this.new_password,
            verify_password : this.verify_password
          }

          requestApi({
            url: '/users/profile/changepassword',
            method: 'PUT',
            data: params,
            callback: (res) => {
              if (res.res_code === '200') {
                let snackBarOptions = {
                  text: this.$t('common.message.modify.success')
                }
                eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)

                this.current_password = ''
                this.new_password = ''
                this.verify_password = ''

                this.$validator.reset()
                this.blnPassword = false
              } else {
                if (res.res_code === '401012') {
                  utils.setTokenRefresh().then(() => {
                    this.fnChangePassword()
                  })
                } else {
                  eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                }
              }
            }
          })
        }
      })
    },

    fnChangeTwoFactor() {
      this.$validator.validateAll('scope_twofactor').then((result) => {
        if(result){
          let pin_code = ''
          if(this.strong_auth_type_code == '3702'){
            pin_code = this.registered_pin_code
          }else if(this.strong_auth_type_code == '3703'){
            pin_code = this.encode_key
          }

          let params = {
            strong_auth_type_code : this.strong_auth_type_code,
            pin_code : pin_code,
            otp_code : this.otp_code
          }

          requestApi({
            url: '/users/profile/changeauth',
            method: 'PUT',
            data: params,
            callback: (res) => {
              if (res.res_code === '200') {
                let snackBarOptions = {
                  text: this.$t('common.message.modify.success')
                }
                eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)

                this.registered_pin_code = ''
                this.registered_pin_code_re = ''
                this.otp_code = ''

                this.$validator.reset()
                this.blnTwoFactor = false
              }else{
                if (res.res_code === '401012') {
                  utils.setTokenRefresh().then(() => {
                    this.fnChangeTwoFactor()
                  })
                } else {
                  eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                }
              }
            }
          })
        }
      })
    },
    // 사인
    fnClearSignFile(){
      this.signFile = null
      this.signSrc = ''
    },
    fnSaveSign() {
      this.$validator.validateAll('scope_signature').then((result) => {
        if(result){
          let params = { sign_image : this.signSrc }
          requestApi({
            url: '/users/profile/sign',
            method: 'PUT',
            data: params,
            callback: (res) => {
              if (res.res_code === '200') {
                let snackBarOptions = {
                  text: this.$t('common.message.modify.success')
                }
                eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)
                this.blnSignature = false
              } else {
                if (res.res_code === '401012') {
                  utils.setTokenRefresh().then(() => {
                    this.fnSaveSign()
                  })
                } else {
                  eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                }
              }
            }
          })
        }
      })
    },

    fnOpenProofOfIdentfy(){
      if (store.state.token.user_status_type_code === '3507' || store.state.token.user_status_type_code === '3531') {
        let option = {
          text: this.$t('signin.proof_document.fields.beging_verified_msg')
        }
        eventBus.$emit('SHOW_SNACKBAR', option)
      } else {
        this.$refs.proofIdentifyModal.dialog_proof = true
      }
    },

    fnModalSuccess(){
      this.fnGetProfile()
      this.fnGetCompanyInfo()
    },

    fnSetSignature() {
      this.blnSignature = true
      this.$refs.signature.dialog_sign = true
    }

  }
}
</script>

<style lang="less">
</style>
